(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["g_password-footer"]) return;
  try {
    
    const pwdFooter = document.querySelector('[data-password-footer]');
    document.documentElement.style.setProperty('--password-footer-height', `${pwdFooter.offsetHeight}px`);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["g_password-header"]) return;
  try {
    
    const pwdHeader = document.querySelector('[data-password-header]');
    document.documentElement.style.setProperty('--password-header-height', `${pwdHeader.offsetHeight}px`);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["giveaway-hub"] && !Shopify.designMode) return;
  try {
    
/* You can move JS to theme.js if preferred */

  } catch(e) { console.error(e); }
})();
})();
